import { useState } from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogActions, DialogContent, Grid } from "@mui/material";
import Loader from "../loader/Loader";

export interface SimpleDialogProps {
  open: boolean;
  onClose: any;
  asyncOperation?: any;
  title: string;
  disableSubmit: boolean;
  submitButtonName?: string;
  showCancelOption: boolean;
  children: any;
}
const SelectionModal = (props: SimpleDialogProps) => {
  const { onClose, open, title } = props;
  const [isOperationInProgress, setOperationInProgress] = useState(false);

  const handleClose = () => {
    onClose();
  };

  const _executeOperation = async () => {
    if (props.asyncOperation) {
      setOperationInProgress(true);
      const result = await props.asyncOperation();
      setOperationInProgress(false);
    }
  };

  return (
    <Dialog open={open} fullWidth={true}>
      <DialogTitle
        sx={{
          m: 0,
          p: 1,
          backgroundColor: "primary.main",
          color: (theme) => theme.palette.grey[50],
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent dividers>
        <Grid container alignItems="center">
          {props.children}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => _executeOperation()}
          size="small"
          disabled={props.disableSubmit}
        >
          {props.submitButtonName ?? "Submit"}
        </Button>
        {props.showCancelOption && (
          <Button variant="outlined" onClick={handleClose} size="small">
            Cancel
          </Button>
        )}
      </DialogActions>
      <Loader isLoading={isOperationInProgress} />
    </Dialog>
  );
};

export default SelectionModal;
